import { useSkeletonTranslation } from 'hooks/useSkeletonTranslation';
import { HeaderContext } from 'providers/HeaderProvider';
import { useContext, useMemo } from 'react';

export function useHeaderTitle() {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error('useHeaderTitle must be used within HeaderProvider');
  }

  const { config } = context;
  const { skeletonT } = useSkeletonTranslation();

  const title = useMemo(() => skeletonT(config.title), [config.title]);
  const subtitle = useMemo(() => (config.subtitle ? skeletonT(config.subtitle) : ''), [config.subtitle]);

  return {
    title,
    subtitle,
  };
}
